import { FC } from 'react';

interface NotFoundProps {}

const NotFound: FC<NotFoundProps> = () => (
  <div className="NotFound">
    <h2>404 Page not found</h2>
  </div>
);

export default NotFound;
